import {
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { auth } from "@/firebase/firebaseConfig";

const updateUserPassword = async (currentPassword, newPassword) => {
  const user = auth.currentUser;

  if (user) {
    try {
      // Реаутентификация пользователя
      const credential = EmailAuthProvider.credential(
        user.email,
        currentPassword,
      );
      await reauthenticateWithCredential(user, credential);

      // Обновление пароля
      await updatePassword(user, newPassword);
      return { success: true, message: "Пароль успешно обновлен!" };
    } catch (error) {
      return { success: false, message: error.message };
    }
  } else {
    return { success: false, message: "Пользователь не аутентифицирован!" };
  }
};

export default updateUserPassword;
